/**
 * DOMPurify that also works in the build-time prerender.
 *
 * The default DOMPurify export binds to the browser's window when the module
 * loads. In Node there is none, and DOMPurify then has no sanitize() at all,
 * so a page that sanitizes HTML could not be prerendered. The prerender
 * (scripts/prerender.mjs) hands in a jsdom window instead, so the static HTML
 * is sanitized by the same library, with the same settings, as in the browser.
 */
import createDOMPurify, { type Config, type DOMPurify } from "dompurify";

let purifier: DOMPurify | null =
  typeof window !== "undefined" && window.document ? createDOMPurify(window) : null;

/** Called once by the prerender with a jsdom window. */
export function setSanitizerWindow(win: unknown): void {
  purifier = createDOMPurify(win as unknown as Window & typeof globalThis);
}

/**
 * Sanitized HTML. Without a DOM (a server render nobody configured), the text
 * is returned with every tag removed rather than unsanitized.
 */
export function sanitizeHtml(html: string, config?: Config): string {
  if (purifier?.isSupported) return purifier.sanitize(html, { ...(config ?? {}), RETURN_TRUSTED_TYPE: false }) as string;
  return html.replace(/<[^>]*>/g, "");
}
